<template>
  <!-- This template is for email notification template -->
  <!-- It's a page. @route => email-gateway/email-template  -->
  <div>
    <x-org-heading heading="Email Templates"></x-org-heading>
    <v-row no-gutters class="theme-background mt-4">
      <v-col sm="3" class="secondary-background py-1 px-1" :data-test-id="`${dataTestId}__email-template-list`">
        <v-container
          class="template-item-container mt-1 clickable"
          v-for="(template, index) in templates"
          :key="template.id"
          :class="{ 'mt-0': index === 0 }"
          @click="() => getTemplate(index)"
          :data-test-id="`${dataTestId}__email-template-item-${index+1}`"
        >
          <v-row no-gutters>
            <v-icon
              size="14"
              class="icon"
              :class="{ 'selected-template': currentSelected === index }"
              >email</v-icon
            >
            <h4
              class="ml-4"
              :class="{ 'selected-template': currentSelected === index }"
            >
              {{ template.displayName }}
            </h4>
          </v-row>
        </v-container>
        <div v-if="!templates.length">No Templates</div>
      </v-col>
      <v-col sm="9">
        <v-container class="editor-container">
          <h5 class="mb-6 description" v-if="templates.length">
            {{ templates[currentSelected].templateDescription }}
          </h5>

          <p class="top-label py-0 my-0 mb-1 f-12">Subject</p>
          <v-text-field
            flat
            solo
            filled
            :value="template.title"
            v-model="template.title"
            :data-test-id="`${dataTestId}__subject-input`"
          ></v-text-field>
          <v-spacer class="mt-4"></v-spacer>

          <p class="py-0 top-label my-0 mb-1 f-12">Body</p>
          <!-- WYSIWYG  Editor -->
          <div :data-test-id="`${dataTestId}__body-input`">
            <trumbowyg
            id="my-editor"
            v-model="template.rawMessage"
            :config="editorConfig"
            :data-test-id="`${dataTestId}__body-text-area`"
            ></trumbowyg>
          </div>
          <v-spacer class="mt-4"></v-spacer>

          <!-- Action buttons -->
          <v-row no-gutters justify="end">
            <!-- To get xift default template -->
            <x-button
              class="mb-12"
              color="#58E2C2"
              buttonText="Default"
              outline
              @click="() => getTemplate(currentSelected, 'xift', true)"
              :data-test-id="`${dataTestId}__default-btn`"
            />
            <!-- To reset the template back to inital state  -->
            <x-button
              class="mb-12 ml-2"
              color="rgb(255, 79, 79)"
              buttonText="Reset"
              outline
              @click="resetTemplate"
              :data-test-id="`${dataTestId}__reset-btn`"
            />
            <!-- To subnit the updated template -->
            <x-button
              class="mb-12 ml-2"
              color="#58E2C2"
              buttonText="Save"
              @click="submitTemplate"
              :data-test-id="`${dataTestId}__save-btn`"
            />
          </v-row>
          <!-- Available tokens for template -->
          <!-- Tokens are variable part of the template -->

          <p class="top-label py-0 my-0 mb-1 f-12">Tokens</p>
          <x-table
            :showPagination="false"
            :showResults="false"
            :showPageSizeSelector="false"
            :columns="columns"
            :tableRows="availableTokens"
            :data-test-id="`${dataTestId}__token-table`"
          >
            <template slot="table_item" slot-scope="props">
              <tr
                v-for="{ key, details, defaultValue } in props.tableRows"
                :key="key"
              >
                <td @click="() => addToken(key)" class="clickable" :data-test-id="`${dataTestId}__token-table__token-${key}`">
                  {{ key }}
                </td>
                <td>{{ details }}</td>
                <td>{{ defaultValue }}</td>
              </tr>
            </template>
          </x-table>
        </v-container>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import jQuery from 'jquery';
import NotificationTemplateService from '@/services/NotificationTemplateService';
// imported  vue-trumbowyg editor
import Trumbowyg from 'vue-trumbowyg';
// importing editor css
import 'trumbowyg/dist/ui/trumbowyg.css';
export default {
  components: { trumbowyg: Trumbowyg },
  data() {
    return {
      // current selected template
      currentSelected: 0,
      // editor options
      editorConfig: {
        allowContent: true
      },
      // columns for tokens table
      columns: [
        { label: 'Token' },
        { label: 'Details' },
        { label: 'Sample Value' }
      ],
      // available tokens for selected template
      availableTokens: [],
      // templates list
      templates: [],
      // current selected template details
      template: {
        title: '',
        rawMessage: ''
      },
      dataTestId:'configuration__email-templates'
    };
  },
  props: ['title'],
  watch: {
    currentlySelectedOrgId: function() {
      this.getTemplate(this.currentSelected);
    }
  },

  // whenever the component is mounted get templates list for the org
  mounted() {
    this.getTemplates();
  },
  methods: {
    /**
     * Takes two params
     * @param {number} index for current selected template from list
     * @param {string} orgID for orgId
     */
    async getTemplate(index, orgID, replace) {
      this.currentSelected = index;

      this.availableTokens = this.templates[index].templateKeys;
      const templationDefinition = await NotificationTemplateService.getTemplateDefinition(
        {
          templateId: this.templates[index].id,
          channelName: 'EMAIL',
          orgID
        }
      );
      const parsed = this.parseResponse(templationDefinition);

      if (replace) {
        this.template.rawMessage = parsed[0].rawMessage;
        this.template.title = parsed[0].title;
        this.template.details = parsed[0].details;
        this.snackbar('success', 'loaded default template');
      } else {
        this.template = parsed[0];
      }
    },
    // reset the current selected template to initial state
    async resetTemplate() {
      this.getTemplate(this.currentSelected);
    },

    // add currently selected token to the template
    async addToken(token) {
      jQuery('#my-editor').trumbowyg('restoreRange');
      jQuery('#my-editor').trumbowyg('execCmd', {
        cmd: 'insertText',
        param: `{${token}}`,
        forceCss: false
      });
      // insertHTML(`{${token}}`);
    },

    /**
     * submitTemplate performs two tasks
     * 1. Update the current selected template definition
     * 2. Create new template definition if orgId is xift
     *
     */

    async submitTemplate() {
      if (!this.template.title || !this.template.rawMessage) {
        return this.snackbar('error', this.$message.CANNOT_BE_EMPTY);
      }
      const orgId = this.currentlySelectedOrgId;
      const body = {
        notificationChannel: 'EMAIL',
        details: this.template.details || 'abcd',
        rawMessage: this.template.rawMessage,
        title: this.template.title
      };
      if (this.template.orgId === 'xift' || !this.template.orgId) {
        body['orgId'] = orgId;
        NotificationTemplateService.createTemplateDefinition({
          templateName: this.templates[this.currentSelected].templateName,
          bodyData: body
        }).then(() => this.snackbar('success', this.$message.ADDED_SUCCESS));
      } else {
        NotificationTemplateService.updateTemplateDefinition({
          templateId: this.template.id,
          bodyData: body
        }).then(() => this.snackbar('success', this.$message.UPDATE_SUCCESS));
      }
    },
    // gets the template list
    async getTemplates() {
      const templates = await NotificationTemplateService.getAllOrgTemplates();
      const parsed = this.parseResponse(templates);
      if (parsed && parsed[0].length) {
        this.templates = parsed[0];
        this.getTemplate(0);
      } else {
        return this.snackbar('error', this.$message.NO_RESULTS);
      }
    }
  }
};
</script>
<style scoped>
.template-item-container {
  background-color: #fff;
}

.f-12 {
  font-size: 12px;
}
.selected-template {
  color: #58e2c2;
}
.clickable {
  cursor: pointer;
}
.description {
  color: #525252;
}
.icon {
  padding: 4px;
  border-radius: 20px;
  background-color: #eee;
}
</style>
